import { useEffect, useState } from 'react';
import { APP_CONFIG, detectDevice, generateAndroidIntentUrl } from '../config/appConfig';
import './AppFallback.css';

function AppFallback({ onAppDetected }) {
  const [loading, setLoading] = useState(true);
  const [device, setDevice] = useState(null);
  const [redirectInfo, setRedirectInfo] = useState('');
  const [showManual, setShowManual] = useState(false);

  useEffect(() => {
    const tryAppLaunch = (callback) => {
      const detectedDevice = detectDevice();
      let appLaunched = false;

      // Спробуємо відкрити додаток через deep link
      const currentUrl = window.location.href;
      let appUrl = '';

      if (detectedDevice.isIOS) {
        // Для iOS використовуємо universal link (поточний URL)
        appUrl = currentUrl;
      } else if (detectedDevice.isAndroid) {
        // Для Android використовуємо intent
        appUrl = generateAndroidIntentUrl(currentUrl);
      }

      if (appUrl && detectedDevice.isMobile) {
        // Встановлюємо таймер для визначення чи додаток відкрився
        const timeout = setTimeout(() => {
          if (!appLaunched) {
            callback(false);
          }
        }, 2500);

        // Якщо сторінка стане невидимою, значить додаток відкрився
        const handleVisibilityChange = () => {
          if (document.visibilityState === 'hidden') {
            appLaunched = true;
            clearTimeout(timeout);
            callback(true);
          }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Спробуємо відкрити додаток
        if (detectedDevice.isAndroid) {
          window.location.href = appUrl;
        } else {
          // Для iOS Universal Links повинні спрацювати автоматично
          // Якщо через 1 секунду сторінка ще видима, значить додаток не відкрився
          setTimeout(() => {
            if (!appLaunched && document.visibilityState === 'visible') {
              callback(false);
            }
          }, 1500);
        }

        // Очищення listener при unmount
        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          clearTimeout(timeout);
        };
      } else {
        callback(false);
      }
    };

    const redirectToStore = (detectedDevice) => {
      if (detectedDevice.isIOS) {
        setRedirectInfo('Переспрямовуємо в App Store...');
        setTimeout(() => {
          window.location.href = APP_CONFIG.ios.appStoreUrl;
        }, 1500);
      } else if (detectedDevice.isAndroid) {
        setRedirectInfo('Переспрямовуємо в Google Play...');
        setTimeout(() => {
          window.location.href = APP_CONFIG.android.playStoreUrl;
        }, 1500);
      } else {
        // Для десктопу показуємо опції
        setShowManual(true);
        setLoading(false);
        setRedirectInfo('Оберіть платформу для завантаження');
      }
    };

    const init = () => {
      const detectedDevice = detectDevice();
      setDevice(detectedDevice);

      // Якщо це мобільний пристрій, спробуємо відкрити додаток
      if (detectedDevice.isMobile) {
        const cleanup = tryAppLaunch((appOpened) => {
          if (appOpened) {
            // Додаток відкрився, повідомляємо батьківський компонент
            if (onAppDetected) {
              onAppDetected();
            }
          } else {
            // Додаток не відкрився, переспрямовуємо в store
            redirectToStore(detectedDevice);
          }
        });

        return cleanup;
      } else {
        // Для десктопу показуємо опції завантаження
        setTimeout(() => {
          setShowManual(true);
          setLoading(false);
          setRedirectInfo('Оберіть платформу для завантаження');
        }, 1000);
      }
    };

    const cleanup = init();
    return cleanup;
  }, [onAppDetected]);

  if (!device) return null;

  return (
    <div className="app-fallback">
      <div className="app-fallback__container">
        <div className="app-fallback__icon">📱</div>
        <h1 className="app-fallback__title">Offer App</h1>
        <p className="app-fallback__description">
          Для кращого досвіду користування, завантажте наш мобільний додаток
        </p>

        {loading && (
          <div className="app-fallback__loading">
            <div className="app-fallback__loader"></div>
            <p>Визначення пристрою...</p>
          </div>
        )}

        {showManual && (
          <div className="app-fallback__manual">
            <a
              href={APP_CONFIG.ios.appStoreUrl}
              className="app-fallback__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              📱 Завантажити для iOS
            </a>
            <a
              href={APP_CONFIG.android.playStoreUrl}
              className="app-fallback__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              🤖 Завантажити для Android
            </a>
          </div>
        )}

        {redirectInfo && (
          <div className="app-fallback__info">
            {redirectInfo}
          </div>
        )}
      </div>
    </div>
  );
}

export default AppFallback;